import { Link } from '../interface';

export const favicon = new Link('icon');
